import { mode } from '@chakra-ui/theme-tools'

// https://github.com/chakra-ui/chakra-ui/blob/master/packages/theme/src/components/menu.ts
export const Menu = {
  baseStyle: (props) => ({
    item: {
      cursor: 'pointer',
      _focus: {
        bg: mode(`gray.50`, `whiteAlpha.100`)(props),
      },
    },
    list: {
      py: 0,
      borderRadius: 'lg',
      boxShadow: mode(`lg`, `dark-lg`),
    },
  }),
}
